// extracted by mini-css-extract-plugin
export default {"redirect-modal":"redirectModal_redirect-modal__BojO6","modal-content":"redirectModal_modal-content__yRiFK","modal-text":"redirectModal_modal-text__CyK+x"};